import { useEncodeSpecificationApi } from "../../../common/api/orders-api/encode-specification/useEncodeSpecificationApi";

export const useAdminEncodeSpecificationApi = () => {
    const {
        createEncodeSpecificationMpeg1,
        createEncodeSpecificationMpeg4,
        updateEncodeSpecificationMpeg1,
        updateEncodeSpecificationMpeg4,
        getAllEncodeSpecifications,
        validateFfmpegCommand,
        cloneEncodeSpecification
    } = useEncodeSpecificationApi();

    return {
        createEncodeSpecificationMpeg1,
        createEncodeSpecificationMpeg4,
        getAllEncodeSpecifications,
        updateEncodeSpecificationMpeg1,
        updateEncodeSpecificationMpeg4,
        validateFfmpegCommand,
        cloneEncodeSpecification
    };
};
